import React, { FunctionComponent, useRef, useState } from "react";
import {
    Grid,
} from "@material-ui/core";
import { useBillStyles } from "./useBillStyles";
type WithBillItemDetailsProps = {
    billDetails: any;
    arabicDetails: any;
}
export const BillItemDetails: FunctionComponent<WithBillItemDetailsProps> = ({
    billDetails,
    arabicDetails
}) => {
    const classes = useBillStyles();

    return (
        <div>
            <Grid
                container
                direction="row"
            >
                <Grid item xs={12}>
                    <Grid container
                        direction="row"
                        spacing={3}
                        
                    >
                        <Grid item xs>
                            <Grid container style={{ backgroundColor: "#2a3e52" }}>
                                <Grid item xs={1}  className={classes.billItemListHeadStyle}>
                                    {arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_SERIAL_NO") !== undefined ?
                                        arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_SERIAL_NO").arabic_name : ""}
                                    <br />
                            Sl.No
                        </Grid>
                                <Grid item xs={2}  className={classes.billItemListHeadStyle}>
                                    {arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_BARCODE") !== undefined ?
                                        arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_BARCODE").arabic_name : ""}
                                    <br />
                            Barcode
                        </Grid>
                                <Grid item xs={5} className={classes.billItemListHeadStyle} >
                                    
                                    {arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_DESCRIPTION") !== undefined ?
                                        arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_DESCRIPTION").arabic_name : ""}
                                    <br />
                            Description
                        </Grid>
                                <Grid item xs={1} className={classes.billItemListHeadStyle}>
                                    {arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_QUANTITY") !== undefined ?
                                        arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_QUANTITY").arabic_name : ""}
                                    <br />
                            Qty
                        </Grid> 
                        {/* <Grid item xs={1} className={classes.billItemListHeadStyle} style={{paddingRight:"55px"}}>
                                    {arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_FOC") !== undefined ?
                                        arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_FOC").arabic_name : ""}
                                    <br />
                            Foc
                        </Grid>        */}                 
                                <Grid item xs={1} className={classes.billItemListHeadStyle}>
                                    {arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_RATE") !== undefined ?
                                        arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_RATE").arabic_name : ""}
                                    <br />
                            Rate
                        </Grid>
                                <Grid item xs={1} className={classes.billItemListHeadStyle}
                                    style={{ textAlign: "right",paddingRight:"0.25em" }}>
                                    {arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_TOTAL") !== undefined ?
                                        arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_TOTAL").arabic_name : ""}
                                    <br />
                            Total
                        </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* <Divider /> */}
                    <Grid container direction="row">
                        {
                            billDetails &&
                            billDetails.map((item: any) => (
                                <Grid item xs={12} style={{ fontSize: "1.10em" }}>
                                    <Grid container
                                        direction="row"
                                        spacing={3}
                                        className={classes.billItemDescriptionStyle}
                                    >
                                        <Grid item xs={1} style={{ textAlign: "center" }}>{`${billDetails.indexOf(item) + 1}`}</Grid>
                                        <Grid item xs={2} style={{ textAlign: "center" }} >{item.ref_plu}</Grid>
                                        <Grid item xs={5} style={{ textAlign: "left" }}>{(item.item_name).toLowerCase().replace(/\b\w/g, (l: any) => l.toUpperCase())}</Grid>
                                        <Grid item xs={1}  style={{ textAlign: "center" }}>{item.total_quantity}</Grid>
                                       {/*  <Grid item xs={1} >{Number(item.foc_qty).toFixed(2)}</Grid> */}
                                        <Grid item xs={1} style={{ textAlign: "center" }}>{item.item_price}</Grid>
                                        <Grid item xs={1} style={{ textAlign: "right" }}>{item.total_price}</Grid>
                                    </Grid>
                                    {/* <Divider style={{ backgroundColor: "#2978ca" }}/> */}
                                </Grid>
                            )

                            )

                        }
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}